var r={};function n(){return r}export{n as getDefaultOptions};
